import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * 階層タグが更新可能できるかチェックするカスタムフック
 *
 * @param {Array} timelines - 写真一覧画面で表示する写真データ一覧
 * @param {Object} checkbox - 選択しているチェックボックスの情報
 * @param {Object} selectedMediaInfo - 選択されたメディア(写真)の情報
 * @returns {boolean} - 更新可能の状態を表す真偽値
 */
const useCheckUpdateHierarchyTag = (timelines, checkbox, selectedMediaInfo) => {
  const [canUpdateHierarchyTag, setCanUpdateHierarchyTag] = useState(true);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.includes('/ds/timeline')) {
      const tagIds = timelines
        .filter(timeline => checkbox.ids.includes(timeline.id))
        .map(timeline => timeline.tags);

      const hasMultipleTags = tagIds.some(tagId => tagId.length > 1);
      if (hasMultipleTags) {
        setCanUpdateHierarchyTag(false);
      }
    }

    if (location.pathname.includes('/ds/media')) {
      // selectedMediaInfo.tagsにはnullが含まれているため、nullを除外する
      const filteredTags = selectedMediaInfo.tags.filter(tag => tag !== null);
      if (filteredTags.length > 1) {
        setCanUpdateHierarchyTag(false);
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return canUpdateHierarchyTag;
};

export default useCheckUpdateHierarchyTag;
